module.exports = __webpack_public_path__ + "zoom_in-black-24dp.svg?8dffefd1d696421733b086193fdb57f3";